import { GrossMassValidationResult } from '../../consignment/models/request'
import { validateGrossMass } from '../../consignment/api/validateGrossMass'

function useDeclarationGrossMassValidation() {
  const validateDeclarationGrossMass = async (
    consignmentId?: number | null,
  ): Promise<GrossMassValidationResult> => {
    if (!consignmentId) throw new Error('Missing consignment ID')
    return await validateGrossMass(consignmentId)
  }

  return {
    validateDeclarationGrossMass,
  }
}

export default useDeclarationGrossMassValidation
